import React, { useState, useEffect } from "react";
import "./RegionalComponent.css";
import StateComponent from "../StateComponent/StateComponent";
import PartyComponent from "../PartyComponent/PartyComponent";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
const partyColor = {
  BJP: "#F57E20",
  "BJP+": "#F57E20",
  BSP: "#0001FF",
  SP: "#CF2323",
  "SP+": "#CF2323",
  CONG: "#4B91CF",
  "CONG+": "#4B91CF",
  OTH: "#575757",
  AAP: "#074200",
  "SAD+": "#F4C300",
  "TMC+": "#004169",
  TMC: "#004169",
  "JD(S)": "#019e3a",
  TMP: "#0474cc",
  "LEFT+": "#dc1c2c",
  NPP: "#f0ac04",
  "NDPP+": "#f42428",
  NPF: "#b4bcec",
};

const websiteUrl = {
  mp: "https://m.mptak.in/article/politics/assembly-election-2023-result-live-updates/81602",
  cg: "https://m.chhattisgarhtak.in/article/politics/elections-result-live-updates/8695",
  rj: "https://m.rajasthantak.com/article/politics/assembly-election-2023-result-live-updates/100959",
    tg: "https://www.newstak.in/politics/assembly-election-2023-result-live-updates?source=tg",
    mz: "https://www.newstak.in/politics/assembly-election-2023-result-live-updates?source=mz",
  };

const partyBoxColor = {
    INC: "#4b91cf1a",
    CONG: "rgb(75 145 207 / 28%)",
    "BJP+": "#f57e201a",
    BJP: "rgb(245 126 32 / 26%)",
    OTH: "rgb(157 157 157 / 30%)",
    BSP: "#6060d81a",
    "SP+": "#cf23231a",
};

const stateSlug = {
  mp: "Madhya Pradesh",
  rj:"Rajasthan",
  cg:"Chhattisgarh",
  tg: "Telangana",
  mz: "Mizoram",
};

const stateSlugHindi = {
  mp: "मध्य प्रदेश",
  rj:"राजस्थान",
  cg:"छत्तीसगढ़",
  tg: "तेलंगाना",
  mz: "मिजोरम",
};

const themeColor = {
  lallantop:"#d9368b",
  mz:"#8ab3dc",
  mp:"#0c8a70",
  cg:"#2d8468",
  tg:"#ee403c",
  rj:"#fed029",

}

const stateUrl = {
  "Uttar Pradesh":
    "https://www.indiatoday.in/election-analysis-dashboard/uttar-pradesh/2022/",
  Punjab: "https://www.indiatoday.in/election-analysis-dashboard/punjab/2022/",
  Uttarakhand:
    "https://www.indiatoday.in/election-analysis-dashboard/uttarakhand/2022/",
  GOA: "https://www.indiatoday.in/election-analysis-dashboard/goa/2022/",
  Manipur:
    "https://www.indiatoday.in/election-analysis-dashboard/manipur/2022/",
};

function RegionalComponent() {
  const [partyData, setPartyData] = useState([]);
  const {state} = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const queryData = partyData?.find(
    (ele) => ele.shortName.toLowerCase() === searchParams.get("state")
  );
  const [currentState, setCurrentState] = useState("Madhya Pradesh");
  const [currentData, setCurrentData] = useState("");
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const theme = params.get('theme');
  const amp = params.get('amp');
  const navigate = useNavigate();
  console.log("theme  is ",state)

  const fetchPartiesData = async () => {
    const resData = await axios.get(
      "https://edr-broadcaster.mobiletak.com/partiesData"
    );
    const partyArr = resData.data.data;
    setPartyData(partyArr);
  };

  useEffect(() => {
    fetchPartiesData();
    // const interval = setInterval(() => fetchPartiesData(), 6050);
    // return () => {
    //   clearInterval(interval);
    // };
  }, []);

  useEffect(()=>{
    setCurrentState(stateSlug[state])
  },[state]);

  useEffect(() => {
    let x = partyData.filter((x) => x.stateName == currentState);
    setCurrentData(x);
  }, [currentState, partyData]);
  useEffect(() => {
    const sse = new EventSource("https://edr-broadcaster.mobiletak.com/sse");
    // const sse = new EventSource("http://localhost:3050/sse");
    function getRealtimeData(dataStream) {
      if (dataStream?.data && dataStream?.data?.length > 0) {
        setPartyData(dataStream?.data);
      }
    }
    sse.onmessage = (res) => getRealtimeData(JSON.parse(res.data));
    sse.onerror = (e) => {
      console.log(e);
      sse.close();
    };
    return () => {
      sse.close();
    };
  }, []);

  console.log("CurrentStat ",partyData, currentState,state)

  return (
    // <div>
    //   {/* <div className="header">
    //     <div className="main-container">
    //       <div className="header-container">
    //         <div className="group_logo">
    //           <img
    //             src="data:image/png;base64,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"
    //             height={"66.66px"}
    //             width={"70px"}
    //             alt="Indiatoday Group"
    //           />
    //         </div>
    //         <div className="header_title">
    //           Election Analysis <span>Dashboard</span>
    //         </div>
    //       </div>
    //     </div>
    //   </div> */}

    //   {/* <div className="main-container">
    //     <div className="bread-crumb">
    //       <a href="javascript:reloadPage();">Home</a>
    //       <span className="page_name" id="page_name"></span>
    //     </div>
    //   </div> */}

    //   <div className="container-body">
    //     {/* <div className="title-bar">
    //       <h2>Assembly Elections 2022</h2>
    //       <span className="home-button" onclick="reloadPage();">
    //         <i className="material-icons">home</i>
    //       </span>
    //     </div> */}

    //     {!searchParams.get("state") && (
    //       <div class="stateyear__filter">
    //       <img src="/tak_election_2023.png" alt="Elections 2022" />
    //       {/* <select
    //         id="another_map_year"
    //         onchange={() => (window.location.href = this.value)}
    //       >
    //         <option value="http://localhost:3000">Select State</option>
    //         <option value="https://www.indiatoday.in/election-analysis-dashboard/west-bengal/2021/">
    //           Uttar Pradesh
    //         </option>
    //         <option value="https://www.indiatoday.in/election-analysis-dashboard/assam/2021/">
    //           Uttrakhand
    //         </option>
    //         <option value="https://www.indiatoday.in/election-analysis-dashboard/kerala/2021/">
    //           Punjab
    //         </option>
    //         <option value="https://www.indiatoday.in/election-analysis-dashboard/tamil-nadu/2021/">
    //           Goa
    //         </option>
    //         <option value="https://www.indiatoday.in/election-analysis-dashboard/puducherry/2021/">
    //           Manipur
    //         </option>
    //       </select> */}
    //     </div>
    //     )}

    //     {/* main content container */}
    //     <div className="content-body">
    //       {!searchParams.get("state") && partyData?.map((state, index) => {
    //         return (
    //           <div className="largeViewBody">
    //             <div className="rowParty" key={`${index}-${state.stateName}`}>
    //               <StateComponent
    //                 stateName={state.stateName}
    //                 totalSeats={state.totalSeats}
    //                 seats={state.seats}
    //                 url={stateUrl[state["stateName"]]}
    //               />

    //               {state.partiesData?.map((party, index1) => (
    //                 <PartyComponent
    //                   data={party}
    //                   color={partyColor[party["partyName"]]}
    //                   key={`${index1}-${index}-${state.stateName}-${party.partyName}`}
    //                   url={stateUrl[state["stateName"]]}
    //                 />
    //               ))}
    //             </div>
    //           </div>
    //         );
    //       })}
    //       {queryData && (
    //         <div className="largeViewBody">
    //           <div className="rowParty" key={`${queryData.stateName}`}>
    //             <StateComponent
    //               stateName={queryData.stateName}
    //               totalSeats={queryData.totalSeats}
    //               seats={queryData.seats}
    //               url={stateUrl[queryData["stateName"]]}
    //             />

    //             {queryData.partiesData?.map((party, index1) => (
    //               <PartyComponent
    //                 data={party}
    //                 color={partyColor[party["partyName"]]}
    //                 key={`${queryData.stateName}-${party.partyName}`}
    //                 url={stateUrl[queryData["stateName"]]}
    //               />
    //             ))}
    //           </div>
    //         </div>

    //       )}

    //       {!queryData && partyData?.map((state, index) => {
    //         return (
    //           <div className="mobViewBody">
    //             <div key={`${index}-${state.stateName}`}>
    //               <StateComponent
    //                 stateName={state.stateName}
    //                 totalSeats={state.totalSeats}
    //                 seats={state.seats}
    //                 url={stateUrl[state["stateName"]]}
    //               />

    //               <div className="rowParty">
    //                 {state.partiesData?.map((party, index1) => (
    //                   <PartyComponent
    //                     data={party}
    //                     color={partyColor[party["partyName"]]}
    //                     key={`${index1}-${index}-${state.stateName}-${party.partyName}`}
    //                     url={stateUrl[state["stateName"]]}
    //                   />
    //                 ))}
    //               </div>
    //             </div>
    //           </div>
    //         );
    //       })}
    //       {queryData && (
    //         <div className="mobViewBody">
    //         <div key={`${queryData.stateName}`}>
    //           <StateComponent
    //             stateName={queryData.stateName}
    //             totalSeats={queryData.totalSeats}
    //             seats={queryData.seats}
    //             url={stateUrl[queryData["stateName"]]}
    //           />

    //           <div className="rowParty">
    //             {queryData.partiesData?.map((party, index1) => (
    //               <PartyComponent
    //                 data={party}
    //                 color={partyColor[party["partyName"]]}
    //                 key={`${queryData.stateName}-${party.partyName}`}
    //                 url={stateUrl[queryData["stateName"]]}
    //               />
    //             ))}
    //           </div>
    //         </div>
    //       </div>
    //       )}
    //     </div>
    //   </div>

    //   {/* <div className="footer">
    //     <div className="copyRightBgSec">
    //       <div className="ei__maincontainer">
    //         <p>
    //           Copyright © 2021 Living Media India Limited. For reprint rights:{" "}
    //           <a href="https://www.indiacontent.in/">Syndications Today</a>.
    //         </p>
    //       </div>
    //     </div>
    //     <script
    //       type="text/javascript"
    //       src="//script.crazyegg.com/pages/scripts/0022/4822.js"
    //       async=""
    //     ></script>
    //   </div> */}
    // </div>
    <>
    <div>
    <div className="election-title-header" style={{display:"flex", marginLeft:"10px",gap:"10px",marginTop:"1rem"}}>
          <div className="election-title"></div>
          <span className="election-title-span">Election Results</span>
        </div>
      <div className="mobile-outer-div">
        <div style={{marginLeft:"10px",marginRight:"10px",marginTop:"10px"}}>
          {/* <img src="/frame-mobile.png" width="100%"></img> */}
        </div>
        {/* <div className="mobile-second-row">
          {partyData?.map((state)=>{
            return <div className={state?.stateName === currentState ? "mobile-second-row-second-box-fill":"mobile-second-row-second-box"} onClick={()=>setCurrentState(state.stateName)}>
            <p>
              {state.stateName} <span>({state.seats} seats)</span>
            </p>
          </div>
          })}
        </div> */}
        <div className="state-header" style={{background: themeColor[state]}}>{stateSlugHindi[state]}</div>
        <div className="mobile-table">
          <div className="mobile-table-row">
            <span style={{ display: "flex", gap: "5px", alignItems: "center" }}>
              PARTY
            </span>
            <span style={{ alignSelf: "center" }}>SEATS {currentData[0]?.totalSeats}</span>
          </div>
          {currentData[0]?.partiesData?.map((party)=>{
            return  <div
            className="mobile-table-row"
            style={{ background: partyBoxColor[party.partyName] ?  partyBoxColor[party.partyName] : partyBoxColor["CONG"] }}

          >
            <span style={{ display: "flex", gap: "5px", alignItems: "center" }}>
              <div
                className="party-color-small"
                style={{ background: partyColor[party?.partyName] }}
              ></div>
              {party?.partyName}
            </span>
            <span style={{ alignSelf: "center" }}>{party?.seatShare}</span>
          </div>
          })}
        </div>
        <div style={{marginTop:"10px",marginRight:"1rem"}}>
          <div className="mobile-last-line">
          <a
                href={websiteUrl[currentData[0]?.shortName.toLowerCase()]}
                target={amp === null ? "_blank": "_top"}
              >
          <span /**onClick={()=>navigate(`/tally/table/${state}/?theme=${state}`)}**/ >यहां क्लिक कर देखिए हर सीट का रिजल्ट</span>
          </a>
          </div>
        </div>
      </div>
      <div className="desktop-outer-div">
        <div
          style={{
            width: "30%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <img src="/frame-desktop.png" width="160px" height="auto"></img>
          <div className="mobile-last-line">
          
            <a
                href={websiteUrl[currentData[0]?.shortName.toLowerCase()]}
                target={amp === null ? "_blank": "_top"}
              >
          <span /**onClick={()=>navigate(`/tally/table/${state}/?theme=${state}`)}**/ >यहां क्लिक कर देखिए हर सीट का रिजल्ट</span>
          </a>
          </div>
        </div>
        <div className="vote-img">
          <img src="/vote.png" width="220px" height="250px"></img>
        </div>
        {/* <div className="desktop-second-row" style={{ width: "20%" }}>
          {partyData?.map((state) => {
            return (
              <div
                className={
                  state?.stateName === currentState
                    ? "mobile-second-row-second-box-fill"
                    : "mobile-second-row-second-box"
                }
                // style={{background:state.stateName === currentState && themeColor[theme]}}
                onClick={() => setCurrentState(state.stateName)}
                style={{background: state?.stateName === currentState ? themeColor[currentState] : ""}}
              >
                <p>
                  {state.stateName} <span>({state.seats} seats)</span>
                </p>
              </div>
            );
          })}
        </div> */}
       
        <div className="mobile-table" style={{ width: "42%" }}>
        <div className="state-header" style={{background: themeColor[state]}}>{stateSlugHindi[state]}</div>
          <div className="mobile-table-row">
            <span style={{ display: "flex", gap: "5px", alignItems: "center" }}>
              PARTY
            </span>
            <span style={{ alignSelf: "center" }}>
              SEATS {currentData[0]?.totalSeats}
            </span>
          </div>
          {currentData[0]?.partiesData?.map((party) => {
            return (
              <div
                className="mobile-table-row"
                style={{ background: partyBoxColor[party.partyName] ?  partyBoxColor[party.partyName] : partyBoxColor["CONG"] }}
              >
                <span
                  style={{ display: "flex", gap: "5px", alignItems: "center" }}
                >
                  <div
                    className="party-color-small"
                    style={{ background: partyColor[party?.partyName] }}
                  ></div>
                  {party?.partyName}
                </span>
                <span style={{ alignSelf: "center" }}>{party?.seatShare}</span>
              </div>
            );
          })}
        </div>
      </div>
      </div>
    </>
  );
}

export default RegionalComponent;
